module.exports = __webpack_public_path__ + "img/ES.a62a83f3.svg";